module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row bar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-3 col-md-12 col-lg-3"
  }, [_c('div', {
    staticClass: "row shared-bar"
  }, [_c('div', {
    staticClass: "col-12 col-md-4 col-lg-12"
  }, [_vm._v("Shared")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2 col-lg-6"
  }, [_c('i', [_c('icon', {
    attrs: {
      "name": "facebook-f"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2 col-lg-6"
  }, [_c('i', [_c('icon', {
    attrs: {
      "name": "twitter"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2 col-lg-6"
  }, [_c('i', [_c('icon', {
    attrs: {
      "name": "linkedin"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2 col-lg-6"
  }, [_c('i', [_c('icon', {
    attrs: {
      "name": "google-plus"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-9 col-md-12 col-lg-9"
  }, [_c('img')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f1d560e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-layout/sidebar/AltmetricStatsBarComponent.vue
// module id = 1457
// module chunks = 1